import React, { FunctionComponent } from "react";

import { partTypeCustom } from "../../../constants/partTypes";
import {
  DealerPackageMappedId,
  updatePartPackageByPartId,
} from "../../../queries/updatePartPackageByPartId";
import { useGetPartPackagesByDealerId } from "../../../queries/useGetPartPackagesByDealerId";
import {
  PackageItem,
  PackagePartItem,
} from "../../../queries/useSearchPartPackagesByVehicle";
import { useDealerAccountInfo } from "../../../stores/hooks/useDealerAccountInfo";
import { PackageInfoForm } from "../PackageInfoForm/PackageInfoForm";

export const packageInfoEditFormId = "package-info-edit-form";

export const PackageInfo: FunctionComponent<{
  getPartQuantity(part: PackageItem): string;
  mappedIds: DealerPackageMappedId[];
  onUpdate: VoidFunction;
  selectedPackage?: PackagePartItem;
  setIsSending: (value: boolean) => void;
}> = ({
  getPartQuantity,
  mappedIds,
  onUpdate,
  selectedPackage,
  setIsSending,
}) => {
  const dealer = useDealerAccountInfo();
  const { mutate } = useGetPartPackagesByDealerId();
  const { sendJson: updatePackage } = updatePartPackageByPartId(
    dealer.dealerId
  );

  const parts =
    selectedPackage?.partDetails.primaryPart.packageItem
      .filter((item) => (item.itemType as string) !== partTypeCustom)
      .map((item) => ({
        partId: item.itemId,
        partType: item.itemType,
        quantity: Number(getPartQuantity(item)),
      })) || [];

  const customParts =
    selectedPackage?.partDetails.primaryPart.packageItem
      .filter((item) => (item.itemType as string) === partTypeCustom)
      .map((item) => ({
        customName: item.itemTitle["en"],
        customNameFr: item.itemTitle["fr"],
        customPartNumber: item.itemPartNumber,
        // NOTE: no price is available for custom parts
        // customPrice: item.itemPrice,
        customTypeName: item.itemTypeDescription["en"],
        customTypeNameFr: item.itemTypeDescription["fr"],
        quantity: Number(getPartQuantity(item)),
      })) || [];

  return (
    <PackageInfoForm
      advancedPrice={
        selectedPackage?.partPricing.primaryPart.advancedPrice ?? null
      }
      onSubmit={async (form): Promise<void> => {
        const packageId = selectedPackage?.partDetails.primaryPart.itemId;
        if (packageId) {
          await updatePackage({ ...form, packageId });
        }
        await mutate();
        onUpdate();
      }}
      customParts={customParts}
      id={packageInfoEditFormId}
      mappedIds={mappedIds}
      parts={parts}
      quoteTotal={null}
      reset={(): void => {}}
      selectedPackage={selectedPackage}
      setIsSending={setIsSending}
    />
  );
};
